import { render, staticRenderFns } from "./BulkUpdateProducts.vue?vue&type=template&id=2b672eaf&scoped=true"
import script from "@/views/Variants/BulkUpdateProducts.ts?vue&type=script&lang=ts&external"
export * from "@/views/Variants/BulkUpdateProducts.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Variants/bulk-update-products.scss?vue&type=style&index=0&id=2b672eaf&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b672eaf",
  null
  
)

export default component.exports